import { Component, OnInit } from '@angular/core';
import { DocumentReader } from 'src/app/modules/core/store/models';
// import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-workflow-cell',
    templateUrl: './workflow-cell.component.html',
    styleUrls: ['./workflow-cell.component.scss'],
    standalone: false
})
export class WorkflowCellComponent implements OnInit {
  colorCode: string;
  workflowStatus: string;

  // constructor(private store: Store<any>) {}
  constructor() {}

  ngOnInit(): void {}

  agInit(params: any): void {
    const document = params.data;
    const reader = new DocumentReader(document);

    const statusName = reader.getFieldValue('workflow_status_name');
    const statusColor = reader.getFieldValue('workflow_status_color');

    if (statusName && statusColor) {
      this.colorCode = statusColor;
      this.workflowStatus = statusName;

      return;
    }

    const workflows = params.workflows;

    const workflowFieldName = params.workflowFieldName ?? 'workflow_uid';
    const workflowStepFieldName = params.workflowStepFieldName ?? 'workflow_step_uid';

    let workflowUId = !!params.data ? reader.getFieldValue(workflowFieldName) : null;
    const workflowStepUId = !!params.data ? reader.getFieldValue(workflowStepFieldName) : params.value;

    if (!workflowUId) {
      const workflow = workflows?.find(wf => wf.workflowSteps.some(wfs => wfs.uId === workflowStepUId));
      workflowUId = !!workflow ? workflow.uId : null;
    }
    if (!workflowUId || !workflowStepUId) {
      return;
    }

    const workflow = workflows?.find(wf => wf.uId === workflowUId);
    const workflowStep = workflow?.workflowSteps?.find(wfs => wfs.uId === workflowStepUId);

    this.colorCode = workflowStep?.statusHtmlColorCode;
    this.workflowStatus = workflowStep?.statusName;
  }
}
